module.exports = __webpack_public_path__ + "img/flugeltor.b24b3cb3.png";